export default __webpack_public_path__ + "static/media/2025 Annual Corporate Governance Report (ACGR) Scorecard.19cc7fbb.pdf";